module.exports = __webpack_public_path__ + "static/img/consultingCenter_4.abe9f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/consultingCenter_4.png
// module id = YrWZ
// module chunks = 1